<template>
  <div>
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: 'ChiefContractList' }">
          待盖章
        </el-breadcrumb-item>
        <el-breadcrumb-item>办理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="rj-page-card">
      <div class="rj-page-card__title">
        合同附件信息
      </div>
      <div class="rj-page-card__content">
        <contract-file ref="contractFile" :contract-num="contractNum" :contract-type="contractType" :item-val="itemVal" />
        <div style="margin-top: 15px;">
          <el-button type="primary" :loading="submitLoading" @click="submit">
            发布并前往付款
          </el-button>
          <el-button type="primary" @click="goBack">
            发布并返回列表
          </el-button>
          <el-button type="primary" @click="goBackSubmission">
            回退待办
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="es6">
import contractFile from './common/contractFile';
import { submitToPayment, updateContractStatusToSubmit, getContractInfoById } from '@/API';
export default {
  data () {
    return {
      submitLoading: false,
      contractType: '',
      itemVal: null
    };
  },
  props: {
    contractNum: {
      type: [String, Number],
      required: true
    }
  },
  components: {
    contractFile
  },
  computed: {},
  methods: {
    submit () {
      if (!this.$refs.contractFile.tableData.length) {
        this.$notify.error({
          message: '请上传合同附件或进行电子签章'
        });
        return;
      }
      this.submitLoading = true;
      let contractAttachments = [];
      this.$refs.contractFile.tableData.forEach((item) => {
        contractAttachments.push({
          fileName: item.fileName,
          fileToken: item.fileToken,
          contractId: this.contractNum
        });
      });
      let params = {
        contractId: this.contractNum,
        contractAttachments: contractAttachments
      };
      submitToPayment(params).then((res) => {
        this.submitLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$router.replace({
            name: 'distribution',
            params: {
              contractNum: json.data
            }
          });
        }
      }).catch(() => {
        this.submitLoading = false;
      });
    },
    goBack () {
      if (!this.$refs.contractFile.tableData.length) {
        this.$notify.error({
          message: '请上传合同附件或进行电子签章'
        });
        return;
      }
      this.submitLoading = true;
      let contractAttachments = [];
      this.$refs.contractFile.tableData.forEach((item) => {
        contractAttachments.push({
          fileName: item.fileName,
          fileToken: item.fileToken,
          contractId: this.contractNum
        });
      });
      let params = {
        contractId: this.contractNum,
        contractAttachments: contractAttachments
      };
      submitToPayment(params).then((res) => {
        this.submitLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$router.go(-1);
        }
      }).catch(() => {
        this.submitLoading = false;
      });
    },
    goBackSubmission () {
      updateContractStatusToSubmit(this.contractNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$router.push({ name: 'Submission', params: { contractNum: json.data } });
        }
      }).catch((res) => {

      });
    },
    initData () {
      getContractInfoById(this.$route.params.contractNum).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.itemVal = json.data;
          this.contractType = json.data.contractType;
        }
      }).catch((res) => {
        console.log(res);
      });
    }
  },
  mounted () {
    this.initData();
  }
};
</script>
<style lang="scss"></style>
